/**
 * Removes leading and trailing slashes from a given path string.
 *
 * @param {string} path - The path string (e.g., "/bank-bank-customer", "/another/path/").
 * @returns {string} The path string without leading/trailing slashes (e.g., "bank-bank-customer", "another/path").
 */
export const removeSlashesFromPath = (path) => {
  if (typeof path !== "string") {
    return ""; // Return an empty string or throw an error for invalid input
  }
  return path.replace(/^\/+|\/+$/g, "");
};
